/* Vey's redesign — Google reviews carousel.
   Pages through review cards (N per page). Each page is one viewport wide;
   we translate the track by whole-viewport pixel steps so it works regardless
   of flex box-model quirks. Prev/next wrap; dots jump; recalculates on resize. */
(function () {
  if (window.customElements && customElements.get('custom-reviews-carousel')) return;

  class CustomReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.veys-reviews__viewport');
      this.track = this.querySelector('[data-reviews-track]');
      this.pageCount = parseInt(this.getAttribute('data-page-count'), 10) || 1;
      this.dots = Array.from(
        (this.parentElement || document).querySelectorAll('[data-reviews-dot]')
      );
      this.index = 0;
      if (this.pageCount < 2 || !this.track || !this.viewport) return;

      var prev = this.querySelector('[data-reviews-prev]');
      var next = this.querySelector('[data-reviews-next]');
      if (prev) prev.addEventListener('click', () => this.goTo(this.index - 1));
      if (next) next.addEventListener('click', () => this.goTo(this.index + 1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () =>
          this.goTo(parseInt(dot.getAttribute('data-reviews-dot'), 10))
        );
      });

      window.addEventListener('resize', () => this.apply());
      this.apply();
    }

    goTo(i) {
      this.index = ((i % this.pageCount) + this.pageCount) % this.pageCount;
      this.apply();
    }

    apply() {
      var w = this.viewport.clientWidth;
      this.track.style.transform = 'translateX(' + -this.index * w + 'px)';
      this.dots.forEach((dot, n) => dot.classList.toggle('is-active', n === this.index));
    }
  }

  customElements.define('custom-reviews-carousel', CustomReviewsCarousel);
})();
